export default __webpack_public_path__ + "static/media/dropdown.1c7eb344.svg";